import { render, staticRenderFns } from "./ProductDetailBoxInfo.vue?vue&type=template&id=ae5a1186&"
import script from "./ProductDetailBoxInfo.vue?vue&type=script&lang=js&"
export * from "./ProductDetailBoxInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports